import * as React from "react";

import "./tree-type.scss";

import {cs}               from "@Common/react/chain-services";
import {csArr}            from "@Common/react/cs-arr";
import {keyed}            from "@Common/react/keyed";
import {scnv}             from "@Common/react/state-change-nested-value";
import {Static2}          from "@Common/react/static-2";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {TreeItem} from "./tree-item/tree-item";
import {scopedState} from "@Common/react/scoped-state";

export const TreeType = ({fieldConfig, state, key, next}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ({eh, domRef}) => {
        return next({
            labelTop: 10,
            invalid: false,
            highlightErrors: () => {
                eh.start();
                scrollIntoView(domRef.get());
            },
            controls: ({showErrors}) => cs(
                // ({}, next) => fragments(
                //     next(),
                //     <pre>{JSON.stringify(state.value?.[key], null, 4)}</pre>
                // ),
                ["selecteds", (_, next) => next(scopedState(state,[key]))],
                ({selecteds}, next) => (
                    <div className="tree-type-7w7">
                        <div className="tree">
                            {next()}
                        </div>
                        {!!selecteds.value?.length && (
                            <div className="list">
                                {selecteds.value.map((code) => cs(
                                    keyed(code),
                                    () => (
                                        <div className="item">
                                            {code} - {findDescription(code, fieldConfig.values)}
                                        </div>
                                    )
                                ))}
                            </div>
                        )}
                    </div>
                ),
                ["items", ({selecteds}, next) => csArr(
                    fieldConfig.values.map(({code, description, children}) => (next) => TreeItem({
                        code, description, children,
                        selecting: {
                            isMidwaySelected: (code) => selecteds.value?.some((c) => c.startsWith(code)),
                            isSelected: (code) => selecteds.value?.includes(code),
                            select: (code) => scnv(selecteds, [], (_) => [..._??[], code]),
                            clearChildren: (code) => scnv(selecteds, [], (_) => _.filter((c) => !c.startsWith(code))),
                            unselect: (code) => scnv(selecteds, [], (_) => _.filter((c) => c !== code)),
                        },
                        next,
                    })),
                    next,
                )],
                ({items}) => items.map((item,i) => cs(
                    keyed(i),
                    () => item.render({
                        onSelect: item.select,
                    }),
                )),
            ),
        })
    },
);

const findDescription = (code, values) => {
    for (const value of values) {
        if (value.code === code) {
            return value.description;
        }
        if (code.startsWith(value.code)) {
            return findDescription(code, Object.values(value.children));
        }
    }
};
